import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import './Auth.css';

const Register = ({ onClose, onLoginClick }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === confirmPassword) {
      alert('Registered successfully');
      onClose();
    } else {
      alert('Passwords do not match');
    }
  };

  return (
    <Box className="authModalContent">
      <IconButton className="closeButton" onClick={onClose} sx={{ position: 'absolute', top: 0, right: 0 }}>
        <Close />
      </IconButton>
      <Typography variant="h5" gutterBottom>
        Register
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirm Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Register
        </Button>
      </form>
      <Grid container justifyContent="center">
        <Grid item>
          <Button onClick={onLoginClick} color="primary">
            Already have an account? Login
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Register;
